<template>
  <div class="shop-summary">
    <slot name="top" />
    <div class="shop-summary__actions">
      <CheckboxComponent v-model="showDefault" :label="$t('showDefaultSelection')" />
    </div>
    <Alert
      v-if="!value.categories.filter(HideDefaultFilter).length"
      class="shop-summary__no-upgrades"
    >
      {{ $t('noUpgradesSelected') }}
    </Alert>

    <table>
      <template
        v-for="(category, ci) in value.categories
          .filter(c => ConditionFilter(c, value))
          .filter(HideDefaultFilter)"
      >
        <tr :key="ci" class="shop-summary__category">
          <td>{{ category.label }}</td>
          <td>
            <slot name="category-right" :item="category" />
          </td>
        </tr>
        <tr
          v-for="(subcategory, si) in category.categories
            .filter(c => ConditionFilter(c, value) && c.items.length)
            .filter(HideDefaultFilter)"
          :key="[ci, si].join('_')"
          class="shop-summary__subcategory"
        >
          <td>{{ subcategory.label }}</td>
          <td>
            <Product
              show-image
              :show-product-link="showProductLink"
              :value="getSelected(subcategory)"
              :currency="value.metadata.currency"
              lock-quantity
            />
          </td>
        </tr>
      </template>
      <tr class="shop-summary__total">
        <td>
          {{ $t('total') }}
          <span style="opacity: 0.5; font-size: 0.6em">{{ $t('includingVat') }}</span>
        </td>
        <td><Total :value="value" :currency="value.metadata.currency" /></td>
      </tr>
    </table>
    <slot name="bottom" />
  </div>
</template>

<script>
import { ConditionFilter } from './utils'
import { CheckboxComponent } from 'vue-elder-checkbox'
import { AlertComponent as Alert } from 'vue-elder-alert'
import { ButtonComponent } from 'vue-elder-button'

import Product from './Product/Card'
import Total from './Total'

export default {
  props: {
    value: Object,
    toggleState: Boolean,
    showProductLink: Boolean,
  },
  data() {
    return {
      showDefault: false,
    }
  },
  computed: {
    selected() {
      if (!this.value) return []
      let items = []
      let target = this.value.categories

      const extract = x => {
        items.push(this.getSelected(x))
        if (x.categories && x.categories.length) x.categories.forEach(extract)
      }

      target.forEach(extract)

      return items.filter(Boolean)
    },
  },
  methods: {
    ConditionFilter,
    HideDefaultFilter(category) {
      if (this.showDefault) return true

      let filter = i => {
        let selected = i.items.find(item => item.selected)
        if (!selected) return false
        return !selected.isDefault
      }

      if ('items' in category) return filter(category)

      return category.categories.map(filter).some(Boolean)
    },
    getSelected(item) {
      return (
        item.selected ||
        (item.items && item.items.find(i => i.selected)) || {
          product: {
            name: this.$t('noShopDefaultProduct'),
          },
          isDummy: true,
          selected: true,
          isDefault: true,
        }
      )
    },
  },
  created() {
    this.showDefault = this.toggleState
  },
  components: {
    Product,
    CheckboxComponent,
    Alert,
    ButtonComponent,
    Total,
  },
}
</script>

<style lang="scss">
.shop-summary {
  table {
    width: 100%;
    border-collapse: collapse;

    td {
      padding: 1rem 0;
    }
  }

  &__actions {
    display: flex;
    justify-content: flex-end;
    gap: 1.5rem;
    align-content: center;
    align-items: center;
    margin-bottom: 1rem;
  }

  &__category {
    font-weight: bold;
    font-size: 1.2em;
    border-bottom: 1px solid var(--border-color);

    td {
      padding-bottom: 0.5rem !important;
    }
  }

  &__subcategory {
    td:first-child {
      font-weight: bold;
      vertical-align: top;
      font-size: 1em;
    }
  }

  &__total {
    font-weight: bold;
    font-size: 1.5em;

    border-top: 2px solid var(--border-color);

    td:first-child {
      display: flex;
      flex-direction: column;
    }

    td:last-child {
      font-size: 1.6em;
      text-align: right;
    }

    @media (max-width: 950px) {
      font-size: 1.3em;
    }
  }

  &__show-default {
    display: flex;
    justify-content: flex-end;
    padding-bottom: 2rem;
  }

  &__no-upgrades {
    margin: 2rem auto;
    max-width: 350px;
    font-size: 0.9em;
    .alert__content {
      justify-content: center;
    }
  }

  .shop-product-card {
    width: 100%;
    margin-left: auto;
    color: inherit;

    box-shadow: none !important;
    background-color: transparent !important;
    cursor: default;
  }
}
</style>
